export const translatedKeys = {
    SELF_GENERATED: 'Auto despacho',
    WEB_GENERATED: 'Central',
    EXTERNAL: 'Fontes externas',
    LEADER_GENERATED: 'Despacho via responsável',
    SENTRY_ALARM: 'Alarme sentry',
    DISPATCH_HELP: 'Chat',
    CITY_HALL: 'Site da prefeitura',
    CONTACT_ID: 'Alarme patrimonial'
}